<template>
    <div>
        <app-layout>
	        <template v-slot:header>
	            <Header :title="$t('logs')"
	                    :isColumns="true"
	                    @filter-div-status="datatable.filterStatus=$event"
	            >
	                <template v-slot:columns>
	                    <div class="mb-1" v-for="(column,key) in datatable.columns">
	                        <b-form-checkbox
	                            :id="'checkbox-'+key"
	                            :name="'checkbox-'+key"
	                            :value="false"
	                            :unchecked-value="true"
	                            v-model="column.hidden"
	                            v-if="column.field!='buttons'"
	                        >
	                            {{ column.label }}
	                        </b-form-checkbox>
	                    </div>
	                </template>
	            </Header>
	        </template>
	        <template v-slot:header-mobile>
		        <HeaderMobile :title="$t('logs')"
		                      :isColumns="true"
		                      @filter-div-status="datatable.filterStatus=$event"
	            >
	                <template v-slot:columns>
	                    <div class="mb-1" v-for="(column,key) in datatable.columns">
	                        <b-form-checkbox
	                            :id="'checkbox-'+key"
	                            :name="'checkbox-'+key"
	                            :value="false"
	                            :unchecked-value="true"
	                            v-model="column.hidden"
	                            v-if="column.field!='buttons'"
	                        >
	                            {{ column.label }}
	                        </b-form-checkbox>
	                    </div>
	                </template>
	            </HeaderMobile>
	        </template>
            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :exportExcel="true"
                              @exportExcel="$refs.datatable.excel()">
                <b-row>
                    <b-col cols="12" md="3">
                        <b-form-group :label="$t('start_date')">
                            <b-form-input type="datetime-local" size="sm" v-model="datatable.queryParams.start_date"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group :label="$t('end_date')">
                            <b-form-input type="datetime-local" size="sm" v-model="datatable.queryParams.end_date"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group :label="$t('user_id')">
                            <b-form-input type="text" size="sm" v-model="datatable.queryParams.user_id"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group :label="$t('login_user_id')">
                            <b-form-input type="text" size="sm" v-model="datatable.queryParams.login_user_id"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable ref="datatable"
                       :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       v-show="datatable.showTable"
                       :data-function="callService"></datatable>
        </app-layout>
    </div>
</template>
<script>
    import AppLayout from "@/layouts/AppLayout"
    import Header from "@/layouts/AppLayout/Header"
    import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
    import DatatableFilter from "@/components/datatable/DatatableFilter";
    import Datatable from "@/components/datatable/Datatable";
    import ModelSelectbox from "@/components/interactive-fields/ModelSelectbox.vue";
    import LoginLogsService from "@/services/LoginLogsService";

    export default {
        components: {
            ModelSelectbox,
            AppLayout,
            Header,
	        HeaderMobile,
            DatatableFilter,
            Datatable,
        },
        metaInfo() {
            return {
                title: this.$t('logs')
            }
        },
        data() {
            return {
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: this.$t('id'),
                            field: '_id',
                            hidden: true,
                        },
                        {
                            label: this.$t('user_id'),
                            field: 'user_id',
                            hidden: false,
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('user'),
                            field: 'user',
                            hidden: false,
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('login_user_id'),
                            field: 'login_user_id',
                            hidden: false,
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('login_user'),
                            field: 'login_user',
                            hidden: false,
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('ip'),
                            field: 'ip',
                            hidden: false,
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('created_at'),
                            field: 'created_at',
                            hidden: false,
                            thClass: 'text-center',
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        id: null,
                        user_id:null,
                        start_date:null,
                        end_date:null,
                        sort: 'name',
                        page: 1,
                        limit: 20
                    }
                }
            }
        },
        methods: {
            callService(config) {
                return LoginLogsService.getAll(config)
            },

            filter() {
                this.datatable.queryParams.page = 1;
                this.$refs.datatable.getRows();
            },
            filterClear() {
                this.datatable.queryParams.user_id = null;
                this.datatable.queryParams.start_date = null;
                this.datatable.queryParams.end_date = null;
                this.datatable.queryParams.page = 1;

                this.$nextTick(() => {
                    this.$refs.datatable.getRows();
                });
            },
            getRows() {
                this.$refs.datatable.getRows();
            },
        }
    };
</script>

